module.exports = __webpack_public_path__ + "static/BasinBulteni_Catalyst_Sprint3_eng-1cf158e7d74c77901390fbf43f264173.png";